<template>
  <aside class="aside-menu">

  </aside>
</template>

<script>
export default {
  name: 'c-aside'
};
</script>



// WEBPACK FOOTER //
// Aside.vue?165fdf7a